
/**
 * Singleton Redux Toolkit listener middleware instance.
 *
 * This middleware enables registering side-effect listeners for Redux actions
 * (such as timers, logging, analytics, etc) outside of reducers and thunks.
 *
 * Export both the middleware and the startListening function for use in store setup
 * and listener registration, ensuring only one instance is used throughout the app.
 */
import { createListenerMiddleware } from '@reduxjs/toolkit';

export const listenerMiddleware = createListenerMiddleware();
export const { startListening } = listenerMiddleware;
